import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';

function App() {
  return (
    <BrowserRouter>
      {/* Other components like a navigation bar can go here if needed on all pages */}
      <Routes>
        {/* Define the routes and the elements (components) to render */}
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />        
        
        {/* A route for when no other path matches (404 page) */}
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
